export default "__VITE_ASSET__CkOyoMYg__"